import { useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import classNames from 'classnames'

import ChildSocialFeatureSettings from '../../common/ChildSocialFeatureSettings/ChildSocialFeatureSettings'
import { AccountContext } from '../AccountContext'

import classes from './PrivacySettingsForm.module.scss'

const PrivacySettingsForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { user, submitDisabled, updateAction } = useContext(AccountContext)

  const settings = user?.user_settings || {}
  const initialContent = settings.allow_posting_content ?? true
  const initialComments = settings.allow_posting_comments ?? true

  const [allowPostingContent, setAllowPostingContent] = useState(initialContent)
  const [allowPostingComments, setAllowPostingComments] = useState(initialComments)
  const [isUpdating, setIsUpdating] = useState(false)

  const hasChanges = allowPostingContent !== initialContent || allowPostingComments !== initialComments

  const handleSubmit = async (e) => {
    e.preventDefault()

    const partialUser = {
      id: user.id,
      ...(settings.id && { 'user_setting_attributes[id]': settings.id }),
      'user_setting_attributes[allow_posting_content]': allowPostingContent,
      'user_setting_attributes[allow_posting_comments]': allowPostingComments,
    }

    try {
      setIsUpdating(true)
      const newState = await dispatch(updateAction(partialUser))

      if (newState.type === 'UI_ERROR') {
        if (newState.status === 503) {
          toast.error(t('account.privacySettings.updateUnavailable'))
        } else {
          toast.error(t('account.privacySettings.updateError'))
        }
      } else {
        toast.success(t('account.privacySettings.updateSuccess'))
      }
    } catch {
      toast.error(t('account.privacySettings.updateError'))
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classNames(classes.container, 'animated fadeIn')}>
      <div className='row'>
        <h4 className={classes.title}>{t('account.privacySettings.title')}</h4>
      </div>

      <ChildSocialFeatureSettings
        allowPostingContent={allowPostingContent}
        allowPostingComments={allowPostingComments}
        onChangePostingContent={setAllowPostingContent}
        onChangePostingComments={setAllowPostingComments}
      />

      <div className='row mt-5'>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={isUpdating || submitDisabled || !hasChanges}
        >
          {isUpdating ? t('account.common.savingChanges') : t('common.action.saveChanges')}
        </button>
      </div>
    </form>
  )
}

export default PrivacySettingsForm
